import _set from 'lodash/set';

export const patchState = (state, action) => ({ ...state, ...action.payload });
export const updateProp = (state, action) => ({ ...state, [action.payload.prop]: action.payload.value });
export const updateNestedProp = (state, path, value) => {
  const cloned = {...state};
  _set(cloned, path, value);
  return cloned;
};

